import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaidOffCard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 46,
	viewBox: "0 0 58 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 14,
			width: 44,
			height: 32,
			rx: 4,
			fill: "#12875E"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 19.2539,
			width: 44,
			height: 6,
			fill: "#09442F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 38.5176,
			width: 8,
			height: 2,
			rx: 1,
			fill: "#94C9B7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 38.5176,
			width: 8,
			height: 2,
			rx: 1,
			fill: "#94C9B7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23,
			y: 38.5176,
			width: 8,
			height: 2,
			rx: 1,
			fill: "#94C9B7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33,
			y: 38.5176,
			width: 8,
			height: 2,
			rx: 1,
			fill: "#09442F"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_410",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 34,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 34,
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_410)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M44.6 13.8L42.45 11.65C42.2667 11.4667 42.0333 11.375 41.75 11.375C41.4667 11.375 41.2333 11.4667 41.05 11.65C40.8667 11.8333 40.775 12.0667 40.775 12.35C40.775 12.6333 40.8667 12.8667 41.05 13.05L43.9 15.9C44.1 16.1 44.3333 16.2 44.6 16.2C44.8667 16.2 45.1 16.1 45.3 15.9L50.95 10.25C51.1333 10.0667 51.225 9.83333 51.225 9.55C51.225 9.26667 51.1333 9.03333 50.95 8.85C50.7667 8.66667 50.5333 8.575 50.25 8.575C49.9667 8.575 49.7333 8.66667 49.55 8.85L44.6 13.8ZM46 22C44.6167 22 43.3167 21.7375 42.1 21.2125C40.8833 20.6875 39.825 19.975 38.925 19.075C38.025 18.175 37.3125 17.1167 36.7875 15.9C36.2625 14.6833 36 13.3833 36 12C36 10.6167 36.2625 9.31667 36.7875 8.1C37.3125 6.88333 38.025 5.825 38.925 4.925C39.825 4.025 40.8833 3.3125 42.1 2.7875C43.3167 2.2625 44.6167 2 46 2C47.3833 2 48.6833 2.2625 49.9 2.7875C51.1167 3.3125 52.175 4.025 53.075 4.925C53.975 5.825 54.6875 6.88333 55.2125 8.1C55.7375 9.31667 56 10.6167 56 12C56 13.3833 55.7375 14.6833 55.2125 15.9C54.6875 17.1167 53.975 18.175 53.075 19.075C52.175 19.975 51.1167 20.6875 49.9 21.2125C48.6833 21.7375 47.3833 22 46 22Z",
				fill: "#09442F"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgPaidOffCard);
export { ForwardRef as ReactComponent };
